import React, { useState, useCallback } from "react";
import { GridActionsCellItem, useGridApiRef } from "@mui/x-data-grid-pro";
import { requiredCell, validateEmail } from "../../js/utils/inputValidations";
import * as r from "../../js/constants/routes";
import { FilterToolbar, SelectURLGrid } from "../Widgets/Custom Inputs/Select";
import { userState } from "../../js/constants/selectOptions";
import DataGridComponent, {
    rowDisableDelete,
    conditionalEditDisabling,
} from "../Widgets/DataGridComponent";
import PersonAddAltOutlinedIcon from "@mui/icons-material/PersonAddAltOutlined";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import Axios from "axios";
import * as userDiagram from "../../diagrams/userDiagram.json";
import DiagramIcon from "@mui/icons-material/TransformOutlined";
import { ButtonToolbar } from "../Widgets/Custom Inputs/Buttons";
import { userDiagramRoute } from "../../routers/MenuRouter";
import { t } from "react-i18nify";
import { BasicTooltip } from "../Widgets/StyledComponents";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import { historyPush } from "../../js/utils/genericMethods";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import {Paper } from "@mui/material";
import OpenLinkIcon from "@mui/icons-material/LaunchOutlined";
// import { toastr } from "react-redux-toastr";

import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import { dateOnlyToString } from "../../js/utils/genericMethods";
import  {deleteModel}  from "../../js/utils/backend";


// import { IconButton } from '@mui/material';


/** CommentComponent */
const ExternalUsersGrid = ({
    label = t("grid.title.ExternalUsers"),
    baseURL = r.oTUser,
    specificToolbar = null,
    checkboxSelection,
    selectionModel,
    onSelectionModelChange,
    hideActionColumn = false,
    ...props
}) => {
    const apiRef = useGridApiRef();
    const cellFocusField = "IGG";
    const userID = useSelector(state => state.auth.UserID);
    const token = useSelector(state => state.auth.Token);
    const [visitedRow, setVisitedRow] = useState();
    const [selectedUserState, setSelectedUserState] = useState(null);
    const [forceGridRefresh, setForceGridRefresh] = useState(false);

    const { CompanyManager, HoldingManager } = useSelector(state => state.auth);

    const history = useHistory();
    const [tabValue, setTabValue] = useState(0);

    const gridSpecificColumns = [
        {
            field: "IGG",
            headerName: "IGG",
            flex: 1,
            editable: true,
            preProcessEditCellProps: params => {
                const hasError = requiredCell(params, apiRef, "IGG", "IGG");
                return { ...params.props, error: hasError };
            },
        },
        {
            field: "Firstname",
            headerName: t("field.Firstname"),
            flex: 1,
            editable: true,
        },
        {
            field: "Lastname",
            headerName: t("field.Lastname"),
            flex: 1,
            editable: true,
        },
        {
            field: "EMail",
            headerName: "EMail",
            flex: 1,
            editable: true,
            preProcessEditCellProps: params => {
                const hasError = validateEmail(
                    params,
                    apiRef,
                    "EMail",
                    "EMail"
                );
                return { ...params.props, error: hasError };
            },
        },
        {
            field: "State",
            headerName: t("field.State"),
            /* If we do not display toolbar (with proper status workflow), then hide user State (no need to show it) */
            flex: 0.5,
            valueGetter: params => {
                return (t(`diagram.${params.value}`) ?? t("diagram.Valid"))
            }
        },
        {
            field: "ExternalProvider_select",
            headerName: t("field.ExternalProvider"),
            flex: 1,
            width: 200,
            editable: true,
            valueFormatter: params => params.value?.Name,
            sortComparator: (v1, v2) => v1.Name.localeCompare(v2.Name),
            renderEditCell: params => (
                <SelectURLGrid
                    fieldName={"ExternalProviderID"}
                    URL={r.externalProvider}
                    {...params}
                />
            ),
            preProcessEditCellProps: params => {
                const hasError = requiredCell(
                    params,
                    apiRef,
                    "External Provider",
                    "ExternalProvider_select"
                );
                return { ...params.props, error: hasError };
            },
        },
        {
            field: "ExternalProviderID",
            valueGetter: params =>
                params.row?.ExternalProvider_select?.ObjectID,
        },
        {
            field: "External",
            headerName: t("field.External"),
            editable: true,
            valueGetter: _params => true,
            valueSetter: params => ({
                ...params.row,
                External: true,
            }),
        },
    ];

    const diagramStates = userDiagram.default.States;
    const diagramTransitions = userDiagram.default.Transitions;

    console.log("CompanyManager is ", CompanyManager);
    console.log("HoldingManager is ", HoldingManager);

    const specificActionsColumns = (params, _editing, isLocalLoading) => [
        // MEMO : duplicated code with InternalUserGrid, remember to refactor the onClick and uniformize somehow with better transition handling

        <>
            {(CompanyManager || HoldingManager) &&
                (params.row.State === "Removed" ||
                    apiRef.current.state.rows.idRowsLookup[params.id].State ===
                    "Removed") && (
                    <GridActionsCellItem
                        icon={
                            <BasicTooltip title={t("common.Add")}>
                                <PersonAddAltOutlinedIcon />
                            </BasicTooltip>
                        }
                        label={t("common.Add")}
                        className="textPrimary"
                        onClick={() => {
                            const state = diagramStates.find(
                                e => e.Name === "Removed"
                            );
                            const availableTransitions =
                                diagramTransitions.filter(
                                    e => e.From === state.Name
                                );
                            const nextTransition = availableTransitions[0].Name;
                            const config = {
                                headers: {
                                    Authorization: "Bearer " + token,
                                },
                            };
                            Axios.post(
                                `${baseURL}/transition/${params.id}/${nextTransition}`,
                                {},
                                config
                            ).then(() => {
                                setForceGridRefresh(fgr => !fgr);
                                setVisitedRow(params.id);
                            });
                        }}
                        color="inherit"
                        disabled={isLocalLoading}
                    />
                )}
            {(CompanyManager || HoldingManager) &&
                !conditionalEditDisabling(params.row) &&
                !rowDisableDelete(params.row, userID, "ID") &&
                apiRef.current.getRowMode(params.id) !== "edit" && (
                    <GridActionsCellItem
                        icon={
                            <BasicTooltip title={t("common.Remove")}>
                                <HighlightOffIcon />
                            </BasicTooltip>
                        }
                        label={t("common.Remove")}
                        className="textPrimary"
                        onClick={() => {
                            const state = diagramStates.find(
                                e => e.Name === "Valid"
                            );
                            const availableTransitions =
                                diagramTransitions.filter(
                                    e => e.From === state.Name
                                );
                            const nextTransition = availableTransitions[0].Name;
                            const config = {
                                headers: {
                                    Authorization: "Bearer " + token,
                                },
                            };
                            Axios.post(
                                `${baseURL}/transition/${params.id}/${nextTransition}`,
                                {},
                                config
                            ).then(() => {
                                setForceGridRefresh(fgr => !fgr);
                                setVisitedRow(params.id);
                            });
                        }}
                        color="inherit"
                        disabled={isLocalLoading}
                    />
                )}
        </>,
    ];

    const DetailPanelContent = ({ row }) => {
        const apiRefDetailPanel = useGridApiRef();
        const [forceGrdRefDetPanel, setForceGrdRefDetPanel] = useState(false);


        const detailGridSpecificColumns = [
            {
                field: "OtEntityName",
                headerName: t("field.Entity"),
                flex: 1,
                editable: false,
                sortable: true,
            },
            {
                field: "StudyTypeValue",
                headerName: t("field.Category"),
                width: 150,
                editable: false,
                sortable: true
            },
            {
                field: "StudyKind",
                headerName: t("field.StudyKind"),
                width: 150,
                editable: false,
                sortable: true,
            },
            {
                field: "StudyValue",
                headerName: t("field.StudyID"),
                width: 150,
                editable: false,
                sortable: true,
            },
            {
                field: "StudyName",
                headerName: t("field.StudyName"),
                width: 150,
                editable: false,
                sortable: true,
            },
            {
                field: "WorkOrderVal",
                headerName: t("field.WorkOrder"),
                width: 150,
                editable: false,
                sortable: true,
            },

        ];

        const detailSpecificActionsColumns = (
            params,
            editing,
            isLocalLoading
        ) => [
            <>
                      <GridActionsCellItem
                        icon={
                            <BasicTooltip title={t("common.Remove")}>
                                <HighlightOffIcon />
                            </BasicTooltip>
                        }
                        label={t("common.Remove")}
                        className="textPrimary"
                        onClick={async () => {
                            await deleteModel(params.row.WorkOrderID, token,  `WorkOrder`);
                            setForceGrdRefDetPanel(fgr => !fgr);
                        }}
                        color="inherit"
                        // disabled={isLocalLoading}
                    />

                   <GridActionsCellItem
                    icon={
                        <BasicTooltip
                            title={`${t("common.RedirectTo")} 
                            ${
                                params.row.StudyValue
                            }`}
                        >
                           <OpenLinkIcon />
                        </BasicTooltip>
                    }
                    label={t("common.RedirectTo")}
                    className="textPrimary"
                    onClick={async () => {
                       // historyPush(history, await link(params.row, filters, dispatch), { withBackButton: true });

                       const url = `Study/${params.row.StudyID}/fromNode/OTEntityID/${params.row.OtEntityId}`;
                    //    history.push(url, { filters, dispatch });
                    history.push(url);
                      //historyPush( history,await link("datagrid/Study/params.row.studyid/fromNode/OTEntityID/params.row.OTEntityID"), filters, dispatch);
                    }}

                    color="inherit"
                    disabled={isLocalLoading}
                    />
            </>,
        ];


        return (
            <Paper sx={{ m: 1, p: 1 }}>
                 <DataGridComponent
                    apiRef={apiRefDetailPanel}
                    // label={"Study & Work Order"}
                    baseURL={`WorkOrder/workOrderStories/${row.ID}`}
                    cellFocusField={cellFocusField}
                    // disableTitle
                    // disableResearch
                    boxStyle={{ padding: 0, margin: 0 }}
                    isDeleteDisabled={true}
                    isEditDisabled={true}
                    isAddDisabled={true}
                    gridSpecificColumns={detailGridSpecificColumns}
                    specificActionsColumns={detailSpecificActionsColumns}
                    initialState={{
                        sorting: {
                            sortModel: [{ field: "StudyValue", sort: "asc" }],
                        },
                    }}
                    isStandalone={false}
                    // isLocalLoading={false}
                    isRowHeightAuto={false}

                    forceGridRefresh={forceGrdRefDetPanel}
                    visitedRow={visitedRow}
                    
                /> 
            </Paper>
        );
    };    

    const DetailPanelSharedDocContent = ({ row }) => {
        console.log("DetailPanelSharedDocContent", row);
        console.log("tabValue", tabValue);
        const apiRefsharedDocDetailPanel = useGridApiRef();
        const [forceGrdRefDetSharedPanel, setForceGrdRefDetSharedPanel] = useState(false);


        const detailGridSpecificSharedDocColumns = [
            {
                field: "EntityName",
                headerName: t("field.Entity"),
                flex: 1,
                editable: false,
                sortable: true,
            },
            {
                field: "DocumentName",
                headerName: t("field.DocumentName"),
                width: 150,
                editable: false,
                sortable: true,
            },
            {
                field: "ExternalProvider",
                headerName: t("field.ExternalProvider"),
                width: 150,
                editable: false,
                sortable: true
            },
            {
                field: "ExpirationDate",
                headerName: t("field.ExpirationDate"),
                width: 150,
                editable: false,
                sortable: true,
                valueFormatter: params => dateOnlyToString(params.value)
            },
            {
                field: "CategoryName",
                headerName: t("field.CategoryName"),
                width: 150,
                editable: false,
                sortable: true,
            },
            {
                field: "DocumentID",
                headerName: "DocumentID",  
                width: 150,
                editable: false,
                sortable: false,
            },
            {
                field: "OtEntityId",
                headerName: "OtEntityId",  
                width: 150,
                editable: false,
                sortable: false,
            },
            {
                field: "ExternalUserID",
                headerName: "ExternalUserID",
                width: 150,
                editable: false,
                sortable: false,
            },
            {
                field: "CategoryID",
                headerName: "CategoryID", 
            },
        ];

        const detailSpecificSharedDocActionsColumns = (
            params,
            editing,
            isLocalLoading
        ) => [
            <>
                    <GridActionsCellItem
                        icon={
                            <BasicTooltip title={t("common.Remove")}>
                                <HighlightOffIcon />
                            </BasicTooltip>
                        }
                        label={t("common.Remove")}
                        className="textPrimary"
                        onClick={async () => {
                            await deleteModel(params.row.SharedDocID, token, "shareddocument").then(response => {
                                setForceGrdRefDetSharedPanel(fgr => !fgr);
                            });
                        }}
                        color="inherit"
                        disabled={isLocalLoading}
                    />
                   <GridActionsCellItem
                    icon={
                        <BasicTooltip
                            title={`${t("common.RedirectTo")} 
                            ${
                                params.row.CategoryName
                            }`}
                        >
                           <OpenLinkIcon />
                        </BasicTooltip>
                    }
                    label={t("common.RedirectTo")}
                    className="textPrimary"
                    onClick={async () => {
                    const url=`/documentNode/${params.row.CategoryID}/true`;
                    history.push(url);
                    }}

                    color="inherit"
                    disabled={isLocalLoading}
                    />
            </>,
        ];


        return (
            <Paper sx={{ m: 1, p: 1 }}>
                 <DataGridComponent
                    apiRef={apiRefsharedDocDetailPanel}
                    // label={"Shared Documents"}
                    columnVisibilityModel={{
                        DocumentID: false,
                        OtEntityId: false,
                        ExternalUserID: false,
                        CategoryID: false,
                        CategoryName: false,
                    }}
                    baseURL={`SharedDocument/GetSharedDocumentsByUser/${row.ID}`}
                    cellFocusField={cellFocusField}
                    // disableTitle
                    // disableResearch
                    boxStyle={{ padding: 0, margin: 0 }}
                    isDeleteDisabled={true}
                    isEditDisabled={true}
                    isAddDisabled={true}
                    gridSpecificColumns={detailGridSpecificSharedDocColumns}
                    specificActionsColumns={detailSpecificSharedDocActionsColumns}
                    initialState={{
                        sorting: {
                            sortModel: [{ field: "ExpirationDate", sort: "asc" }],
                        },
                    }}
                    isStandalone={false}
                    isLocalLoading={false}
                    isRowHeightAuto={false}
                    forceGridRefresh={forceGrdRefDetSharedPanel}
                /> 
            </Paper>
        );
    };    
    const getDetailPanelContent = useCallback(params => {

        const handleTabChange = (_event, newValue) => {
            console.log("handleTabChange", newValue);
            setTabValue(newValue); // Ensure the state is updated correctly
        };

        return (
            <Paper sx={{ m: 1, p: 1 }}>
                <Tabs value={tabValue} onChange={handleTabChange} aria-label="Detail Panel Tabs">
                <Tab label= {t("common.StudyWorkOrder")}/>
                <Tab label= {t("common.SharedDocument")}/>
                </Tabs>
                {tabValue === 0 && <DetailPanelContent row={params.row} />}
                {tabValue === 1 && <DetailPanelSharedDocContent row={params.row} />}
            </Paper>
        );
    }, [tabValue]); // Add tabValue as a dependency

    return (
        <DataGridComponent
            apiRef={apiRef}
            selectionModel={selectionModel}
            onSelectionModelChange={onSelectionModelChange}
            baseURL={baseURL}
            cellFocusField={cellFocusField}
            label={label}
            gridSpecificColumns={gridSpecificColumns}
            initialState={{
                sorting: {
                    sortModel: [{ field: "Firstname", sort: "asc" }],
                },
            }}
            columnVisibilityModel={{
                "State": !specificToolbar?.disableToolbar,
                "External": false,
                "ExternalProviderID": false
            }}
            toolbar={
                specificToolbar ?? {
                    newAction: (
                        <ButtonToolbar
                            titleTooltip={t("common.AccessWorkflow")}
                            title={t("common.Workflow")}
                            startIcon={<DiagramIcon />}
                            onClick={() => historyPush(history, userDiagramRoute)}
                        />
                    ),
                    newFilter: (
                        <FilterToolbar
                            options={userState.map(e => ({
                                ...e,
                                label: t(`diagram.${e.label}`)
                            }))}
                            placeholder={t("placeholder.UserState")}
                            value={selectedUserState}
                            onChange={(_e, value) =>
                                value
                                    ? setSelectedUserState(value.value)
                                    : setSelectedUserState("")
                            }
                        />
                    ),
                }
            }
            paramURL={
                selectedUserState
                    ? `filter[State]=${selectedUserState}&${r.filter.externalFilter}`
                    : r.filter.externalFilter
            }
            forceGridRefresh={forceGridRefresh}
            isDeleteDisabled={true}
            isEditDisabled={false}
            specificActionsColumns={specificActionsColumns}
            visitedRow={visitedRow}
            checkboxSelection={checkboxSelection}
            hideActionColumn={hideActionColumn}
            getDetailPanelHeight={() => "auto"}
            getDetailPanelContent={apiRef && getDetailPanelContent}
            components={{
                DetailPanelExpandIcon: ChevronRightIcon,
                DetailPanelCollapseIcon: ExpandMoreIcon,
            }}
            {...props}
        />
    );
};


export default ExternalUsersGrid;
